<template>
  <b-alert
    :show="show"
    dismissible
    fade
    variant="danger"
    @dismissed="show = false"
  >
    <div class="alert-body">
      <feather-icon
        size="14"
        icon="AlertTriangleIcon"
        class="mr-50"
      />
      <span>{{ parsedError }}</span>
    </div>
  </b-alert>
</template>

<script>
import { BAlert } from 'bootstrap-vue'

export default {
  name: 'ErrorAlert',
  components: {
    BAlert,
  },
  data() {
    return {
      parsedError: null,
      show: false,
    }
  },
  methods: {
    showError(error, showToast = true) {
      if (!error) {
        this.hideError()

        return null
      }

      let errorMessage = ''

      if (typeof error === 'string') {
        if (Object.keys(this.$t('errors')).includes(error)) {
          errorMessage = this.$t(`errors.${error}`)
        } else {
          errorMessage = error
        }
      }

      if (typeof error === 'object' && errorMessage === '') {
        if (error.response) {
          if (error.response.data) {
            if (error.response.data.code) {
              if (Object.keys(this.$t('errors')).includes(error.response.data.code)) {
                errorMessage = this.$t(`errors.${error.response.data.code}`)
              } else if (error.response.data.code === 'FST_ERR_VALIDATION') {
                errorMessage = this.$t('errors.API_VALIDATION_ERROR', {
                  message: error.response.data.message,
                })
              } else {
                errorMessage = error.response.data.code
              }
            } else {
              errorMessage = error.response.data.message
            }
          } else {
            errorMessage = error.response.message
          }
        } else {
          errorMessage = error.message
        }
      }

      this.parsedError = errorMessage
      this.show = true
      if (showToast) {
        this.showToast()
      }
      console.error(error)

      return errorMessage
    },
    hideError() {
      this.parsedError = null
      this.show = false
    },
    showToast() {
      if (this.parsedError) {
        this.$bvToast.toast(this.parsedError, {
          title: this.$t('errors.error-notification-title'),
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>
